import React, { useEffect, useState, useContext } from "react";
import { Button, Grid, makeStyles, CircularProgress } from "@material-ui/core";
import { CloudUpload } from "@material-ui/icons";
import { UploadFilesComponentContext } from "./context/UploadFilesComponentContext";
import { v4 as uuidv4 } from "uuid";

import FilePreviewCard from "./file_preview_card";
import { useLocation, useParams } from "react-router";
import DataService from "../../Service";
import { useDispatch, useSelector } from "react-redux";
import { showSnackbar } from "../Snackbar/SnackbarActions";
import {
  SET_EMPLOYEE_DROPDOWN_VALUES,
  SET_EMPLOYEE_UPLOAD_FILES,
} from "../../Redux/actions";

const useStyles = makeStyles({
  formControl: {
    width: "100%",
  },
  input: {
    display: "none",
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
  button: {
    margin: "0px",
    backgroundColor: "#3b86ff",
    color: "#fff",
  },
  labelText: {
    color: "#4D4F5C",
    fontSize: "14px",
    lineHeight: "18px",
  },
  previewCard: {
    width: 150,
    height: 100,
    backgroundColor: "#ddd",
    marginBlock: 10,
    borderRadius: 5,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px",
    boxSizing: "border-box",
    marginRight: "16px",
  },
});

export default function UploadFilesComponent(props) {
  const classes = useStyles();
  const { label, name, errorMsg, helperText, buttonLabel, labelStyle } =
    props.componentObject;
  // const coaching_profile_picture = useSelector((state) => state.commonReducer.employeeUploads);

  const dispatch = useDispatch();

  const location = useLocation();
  const params = useParams();

  //Accessing state from Redux
  const OrgId = useSelector(
    (state) => state.organisationDetailsReducer.data.id
  );

  const employeeId = useSelector((state) => state.contactAreaReducer.data.id);

  const { fileDataState, fetchedFilesState } = useContext(
    UploadFilesComponentContext
  );

  const { fileData, setFileData } = fileDataState;

  const { fetchedFiles, setFetchedFiles } = fetchedFilesState;

  const [isEditingPage, setIsEditingPage] = useState(false);

  const [isUploadingFiles, setIsUploadingFiles] = useState(false);
  const [isDeletingFile, setIsDeletingFile] = useState(false);
  const [isFetcingFiles, setIsFetcingFiles] = useState(false);

  const [isEmployeeSection, setIsEmployeeSection] = useState(false);

  // this for resoliving the loading spinner issue
  // for showing the loding spinner only on the selected card
  const [fileId, setFileId] = useState(0);

  // this for fetching uploaded files
  const fetchFiles = () => {
    //fetching uploaded files
    setIsFetcingFiles(true);

    let url =
      isEmployeeSection || employeeId
        ? `/employees/listing_files?employee_id=${params.employeeid ? params.employeeid : employeeId
        }`
        : `/organisations/listing_files?organisation_id=${params.id ? params.id : OrgId
        }`;

    DataService.getDirectData(url)
      .then((res) => {
        const { organisation_documents, employee_images } = res;

        const data = organisation_documents
          ? organisation_documents
          : employee_images;

        setFetchedFiles(data);

        if (!organisation_documents) {
          dispatch({
            type: SET_EMPLOYEE_UPLOAD_FILES,
            payload: res.employee_images,
          });
        }
        setIsFetcingFiles(false);
      })
      .catch((err) => {
        setIsFetcingFiles(false);
        dispatch(showSnackbar("error", ["Something went wrong"]));
      });
  };

  useEffect(() => {
    if (
      location.pathname === `/admin/organisation/${params.id}/edit` ||
      location.pathname ===
      `/admin/organisation/${params.id}/employee/${params.employeeid}/edit`
    ) {
      setIsEditingPage(true);
    } else {
      // setIsEditingPage(false);
    }

    if (
      (location.pathname ===
        `/admin/organisation/${params.id}/employee/${params.employeeid}/edit` &&
        params.employeeid !== undefined) ||
      location.pathname === `/admin/organisation/${params.id}/employee/create`
    ) {
      setIsEmployeeSection(true);
    } else {
      setIsEmployeeSection(false);
    }

    if (OrgId) {
      setIsEditingPage(true);
      fetchFiles();
    }

    if (employeeId) {
      setIsEditingPage(true);
      fetchFiles();
    }
  }, [
    location.pathname,
    params.id,
    params.employeeid,
    OrgId,
    employeeId,
    isEditingPage,
  ]);

  //========================================================================================
  // sending files to the server if the user on the editing phase
  const sendFilesToTheServer = (files) => {
    const fileFormData = new FormData();

    files.forEach((item) => fileFormData.append("file[]", item));

    if (isEmployeeSection) {
      fileFormData.append(
        "employee_id",
        params.employeeid ? params.employeeid : employeeId
      );
    } else {
      fileFormData.append("organisation_id", params.id ? params.id : OrgId);
    }

    fileFormData.append("file_type", name);

    setIsUploadingFiles(true);

    const url = isEmployeeSection ? "employee_file_upload" : "file_upload";

    DataService.createData(fileFormData, url)
      .then((res) => {
        setIsUploadingFiles(false);

        dispatch(showSnackbar("success", ["File was added successfully!"]));
        fetchFiles();
      })
      .catch((err) => {
        dispatch(showSnackbar("error", ["Something went wrong"]));
        setIsUploadingFiles(false);
      });
  };

  //========================================================================================
  // storing only local files to the global context
  function fileChangeHandler(event) {
    // send file directly to the server if it is editing phase
    if (isEditingPage) {
      const files = Array.from(event.target.files);
      sendFilesToTheServer(files);
      return;
    }

    // checking, is object exists already or not
    let isObjectPresent = false;
    fileData.forEach((item) =>
      item.type === name ? (isObjectPresent = true) : (isObjectPresent = false)
    );

    // creating a new related object only if it doesn't exist
    // else added the file to the related object that exists
    if (!isObjectPresent) {
      setFileData((prevState) => {
        const updatedState = [...prevState];
        if (event.target.files[0]?.name) {
          updatedState.push({
            id: uuidv4(),
            type: name,
            files: Array.from(event.target.files), //converting files object into array of objects
          });
        }

        return updatedState;
      });
    } else {
      setFileData((prevState) => {
        const updatedState = [...prevState];
        if (event.target.files[0]?.name) {
          updatedState.map((item) => {
            if (item.type === name) item.files.push(event.target.files[0]);
          });
        }
        return updatedState;
      });
    }
  }

  //========================================================================================
  // removing the files locally that is stored in the context
  const fileRemoveHandler = (itemToBeDeletedFrom, indexOfFileToBeDeleted) => {
    setFileData((prevState) => {
      const updatedState = [...prevState];

      updatedState.map((item) => {
        if (itemToBeDeletedFrom === item.id) {
          item.files = item.files.filter(
            (_item, i) => i !== indexOfFileToBeDeleted
          );
        }
      });
      return updatedState.filter((item) => item.files.length > 0);
    });
  };

  //========================================================================================
  // removing the files from the server
  const fileRemoveFromTheServer = (fileId) => {
    setIsDeletingFile(true);

    let url = `/organisations/delete_file?organisation_id=${params.id ? params.id : OrgId
      }&file_id=${fileId}`;
    if (isEmployeeSection) {
      url = `/employees/delete_file?employee_id=${params.employeeid ? params.employeeid : employeeId
        }&file_id=${fileId}`;
    }

    DataService.deleteDirectFeild(url)
      .then((res) => {
        setIsDeletingFile(false);
        dispatch(showSnackbar("success", ["File was deleted successfully!"]));

        // updating context after deleting file from the server
        setFetchedFiles((prevState) => {
          return prevState.filter((item) => item.id !== fileId);
        });
      })
      .catch((err) => {
        setIsDeletingFile(false);
        dispatch(showSnackbar("error", ["Something went wrong"]));
      });
  };

  //========================================================================================
  // for displaying the local files
  const previewSelectedFiles = () =>
    fileData.map((item) => {
      if (name !== item.type) return;
      return item.files.map((file, indexOfFile) => (
        <FilePreviewCard
          key={indexOfFile}
          fileName={file.name}
          removeFileHandler={() => fileRemoveHandler(item.id, indexOfFile)}
        />
      ));
    });

  //========================================================================================
  // for displaying the fetched files
  const previewFetchedFiles = () => {

    if (isFetcingFiles)
      return (
        <h3>
          Loading.. <CircularProgress size={10} />
        </h3>
      );

    return fetchedFiles?.map((file) => {

      if (name !== file.type) return null;

      return (
        <FilePreviewCard
          fileLink={file.url}
          key={file.id}
          fileName={file.name}
          removeFileHandler={() => {
            setFileId(file.id);
            fileRemoveFromTheServer(file.id);
          }}
          fileId={file.id}
          // for identifing on which card loading spiner to be Shown
          isDeletingFile={isDeletingFile && file.id === fileId}
        />
      );
    });
  };

  return (
    <Grid container className={classes.gridRoot}>
      {label && (
        <Grid item xs={12} md={4} style={labelStyle ? labelStyle : { textTransform: "capitalize" }}>
          {label}
          &nbsp;
        </Grid>
      )}
      <Grid item xs={12} md={7}>
        <div>
          <input
            //   accept="image/*"
            className={classes.input}
            id={name}
            multiple
            type="file"
            onChange={fileChangeHandler}
            onClick={(e) => e.target.value = null}
          />

          <label htmlFor={name}>
            <Button
              disableElevation
              variant="contained"
              component="span"
              style={{
                backgroundColor: isUploadingFiles
                  ? "rgba(0, 0, 0, 0.26)"
                  : "#EF7000",
                cursor: isUploadingFiles && "none",
                fontSize: "12px",
                color: "#fff",
                width: buttonLabel ? "none" : "107px",
              }}
              startIcon={isUploadingFiles ? "" : <CloudUpload />}
              disabled={isUploadingFiles}
            >
              {isUploadingFiles ? (
                <CircularProgress size={20} />
              ) : buttonLabel ? (
                buttonLabel
              ) : (
                "Upload"
              )}
            </Button>
          </label>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {isEditingPage ? previewFetchedFiles() : previewSelectedFiles()}
        </div>
        {errorMsg !== undefined ? (
          <span
            style={{
              color: "#a9a9a9",
              fontSize: "0.75rem",
              marginRight: "14px",
            }}
          >
            {errorMsg}
          </span>
        ) : (
          ""
        )}
        {/* {coaching_profile_picture.length === 0 &&  <span style={{color: "#f44336",fontSize:'0.75rem',marginRight:'14px'}}> {helperText}</span>} */}
      </Grid>
    </Grid>
  );
}
